import { CheckCircle2, LoaderCircle, ShieldCheck } from "lucide-react";
import { useCallback, useState } from "react";
import { TurnstileWidget } from "../components/TurnstileWidget";

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export function MobileAuthChallengePage() {
  const [verified, setVerified] = useState(false);
  const onToken = useCallback((token: string) => {
    if (!token) return;
    setVerified(true);
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ type: "turnstile-token", token })
    );
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-5">
      <section className="observatory-panel w-full max-w-md rounded-[1.75rem] p-6 text-center">
        <span className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          {verified ? <CheckCircle2 className="size-6" /> : <ShieldCheck className="size-6" />}
        </span>
        <h1 className="mt-5 text-2xl font-extrabold tracking-tight">
          {verified ? "Đã xác minh" : "Xác minh yêu cầu"}
        </h1>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">
          {verified
            ? "Bạn có thể quay lại biểu mẫu trong ứng dụng."
            : "Hoàn tất bước bảo mật để tiếp tục trên LottoLab VN."}
        </p>
        <div className="mt-6">
          {verified ? (
            <div className="flex min-h-14 items-center justify-center gap-2 rounded-2xl bg-primary/10 text-sm font-bold text-primary">
              <LoaderCircle className="size-4 animate-spin" /> Đang quay lại ứng dụng…
            </div>
          ) : (
            <TurnstileWidget onToken={onToken} />
          )}
        </div>
      </section>
    </main>
  );
}
